import { BaseGetInputModel } from "../../../../../models/http/InputModel/BaseGetInputModel"

type UserUserIdAppealGetParams = {
  userId: string
}

export class UserUserIdAppealGetInputModel extends BaseGetInputModel {
  constructor(private params: UserUserIdAppealGetParams) {
    super()
  }

  get pathParams() {
    return {
      user_id: this.params.userId,
    }
  }
}
